export const LISTS = {
  NEW_LIST: 'newList',
  EXIST_MODAL_TITLE: 'Move to List',
  NEW_MODAL_TITLE: 'Create a List',
  LIST_TYPE: {
    PRIVATE: 'private',
    PUBLIC: 'public',
  },
};

export const LISTS_ERROR = {
  EMPTY_LIST_NAME: 'Please enter a list name.',
};

export const CART_VALIDATION_MESSAGES = {
  EMPTY_NAME: 'Please enter a name.',
  EMPTY_EMAIL: 'Please enter an email address.',
  INVALID_NAME: 'Please enter a valid name.',
  INVALID_EMAIL: 'Please enter a valid email address.',
};

export const CART_FIELD_ACCEPTED_CHARACTERS = {
  EMAIL: /[^a-zA-Z0-9.!#$%&'*+/=?^_`~@-]/g,
  FIRST_NAME: /[^a-zA-Z0-9\s\-.'’]/g,
};

export const CART_FIELD_VALIDATION_RULES = {
  EMAIL: /^[a-zA-Z0-9.!#$%&'*+/=?^_`~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  NAME: /^[a-zA-Z0-9\s\-.'’]+$/,
};
